import { axiosInstance } from './axiosBaseInstance';

export function installAddon(url) {
  return axiosInstance.get(url);
}
